'use client'

import { useCallback } from 'react'
import { useTheme } from '@/components/public/branding/ThemeProvider'
import { formatPrice as baseFormatPrice } from './formatting'

/**
 * Public-storefront hook that returns a price formatter pre-bound to
 * the tenant's currency. Drop-in replacement for `formatPrice` inside
 * any component that lives under the storefront ThemeProvider:
 *
 *   const formatPrice = useFormatPrice()
 *   formatPrice(59.99)  // → "$59.99" or "€59,99" depending on tenant
 *
 * Components in admin views or anywhere outside the storefront should
 * keep using the bare `formatPrice(amount, currency)` and pass the
 * currency explicitly — they don't have access to the public theme.
 */
export function useFormatPrice(): (amount: number | string) => string {
  const { currency } = useTheme()
  return useCallback(
    (amount: number | string) => baseFormatPrice(amount, currency),
    [currency],
  )
}
